/* @ngInject */

export default () => {
  var margin = { top: 10, right: 60, bottom: 20, left: 60 };
  var width = 960;
  var height = 480 - margin.top - margin.bottom;

  return {
    restrict: 'E',
    scope: {
      height: '@',
      data: '='
    },
    link: function (scope, element, attrs) {
      var svg = d3
        .select(element[0])
        .append('svg')
        .attr('class', 'd3-chart-line')
        .attr('width', '100%')
        .attr('height', '100%')
        .attr(
          'viewBox',
          '0 0 ' +
            (parseInt(width) + parseInt(margin.left) + parseInt(margin.right)) +
            ' ' +
            (parseInt(height) + parseInt(margin.top) + parseInt(margin.bottom) + 20)
        )
        .attr('preserveAspectRatio', 'xMinYMin')
        .append('g')
        .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

      var parseTime = d3.timeParse('%Y');
      var x = d3.scaleTime().rangeRound([0, width]);
      var y = d3.scaleLinear().rangeRound([height, 0]);

      scope.data.forEach(function (d) {
        d.y = parseTime(d.y);
        d.v = +d.v;
      });

      x.domain(
        d3.extent(scope.data, function (d) {
          return d.y;
        })
      );
      y.domain(
        d3.extent(scope.data, function (d) {
          return d.v;
        })
      );

      var line = d3
        .line()
        .curve(d3.curveCardinal)
        .x(function (d) {
          return x(d.y);
        })
        .y(function (d) {
          return y(d.v);
        });

      svg
        .append('g')
        .call(d3.axisBottom(x).ticks(scope.data.length))
        .attr('transform', 'translate(0, ' + height + ')');

      svg
        .append('g')
        .call(d3.axisLeft(y).ticks(scope.data.length / 2))
        .append('text')
        .attr('transform', 'rotate(-90)')
        .attr('dy', '0.75em');

      svg
        .append('path')
        .datum(scope.data)
        .attr('fill', 'none')
        .attr('class', 'line')
        .attr('stroke-linejoin', 'round')
        .attr('stroke-linecap', 'round')
        .attr('stroke-width', 2)
        .attr('d', line);
    }
  };
};
